<template>
  <v-container>
    <v-row justify="end">
      <v-btn :to="{name: 'createShare'}">
        <v-icon>mdi-account-plus</v-icon>
        <span class="ml-1">Share with another person</span>
      </v-btn>
    </v-row>
    <v-row justify="center">
      <v-col cols="11">
        <div class="headline">
          Your scans are shared with the following users:
        </div>
        <v-card>
          <v-list>
            <ShareListItem
              v-for="share in shares"
              :key="share.id"
              :user="share"
              @deleted="load"
            />
            <v-list-item v-if="!loaded">
              <v-progress-linear indeterminate />
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import http from '@/http';

import ShareListItem from '@/pages/ListSharesPage/ShareListItem.vue';

export default {
  name: 'ListSharesPage',
  components: {
    ShareListItem,
  },
  data() {
    return {
      shares: [],
      loaded: false,
    };
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      const resp = await http.request({
        url: '/neuralike-user/share/',
        method: 'get',
      });
      this.shares = resp.data;
      this.loaded = true;
    },
  },
};
</script>
